export default {
    nav: 'フィードバック',
    dialog: {
        titleList: 'マイフィードバック',
        titleNew: '新規フィードバック',
        titleDetail: 'フィードバック詳細',
    },
    list: {
        new: '新規フィードバック',
        loading: '読み込み中...',
        empty: 'まだフィードバックはありません。あなたのご意見が製品をより良くします',
        delete: '削除',
    },
    status: {
        pending: '未処理',
        processing: '処理中',
        resolved: '解決済み',
        closed: 'クローズ',
    },
    category: {
        bug: 'バグ',
        suggestion: '提案',
        feature_request: '機能リクエスト',
        other: 'その他',
    },
    form: {
        intro: 'いただいたフィードバックはすべてチームが丁寧に確認します',
        titleLabel: 'タイトル',
        titlePlaceholder: '問題や提案を簡潔に説明してください',
        categoryLabel: 'カテゴリ',
        contentLabel: '説明',
        contentPlaceholder: '詳しく説明していただけると、より迅速に対応できます...',
        cancel: 'キャンセル',
        submit: 'フィードバックを送信',
        submitting: '送信中...',
        bold: '太字',
        italic: '斜体',
        strikethrough: '取り消し線',
        bulletList: '箇条書き',
        orderedList: '番号付きリスト',
        blockquote: '引用',
    },
    success: {
        title: 'フィードバックありがとうございます！',
        message: 'ご意見を受け取りました。チームが丁寧に確認し、できる限り早く対応いたします。',
        viewList: 'フィードバック一覧を見る',
    },
    detail: {
        back: 'リストに戻る',
        replyPlaceholder: '返信を追加...',
        send: '送信',
        sending: '送信中',
        uploadImage: '画像をアップロード',
    },
};
